import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingDialogService } from '../../../shared/ui/loading/loading-dialog.service';
import { NotificationService } from '../../../modules_v2/shared/services/notification.service';
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { CreditosModel } from './creditos.model';
import { CreditosService } from './creditos.service';

@Component({
    selector: 'convfact-creditos',
    templateUrl: './creditos.component.html',
    styleUrls: ['./creditos.component.css'],
    standalone: false
})

export class CreditosComponent implements OnInit {

  public creditos = new CreditosModel;
  public spinner: boolean = false;
  public ready: boolean = false;

  constructor(
    private creditosService: CreditosService,
    public snackBar: MatSnackBar,
    private router: Router,
    private loadingDialog: LoadingDialogService,
    private notify: NotificationService,
  ) { }

  public ngOnInit(): void {
    const temp = this.router.url.split('/');
    this.spinner = true;
    if (temp.length == 6) {
      const uid = temp[5];
      this.creditosService.get(uid)
        .then(response => {
          this.creditos = response;
          this.spinner = false;
          this.ready = true;
        })
        .catch(() => {
          this.spinner = false;
          this.notify.error('No se pudo cargar el crédito');
        });
    }
    else {
      this.spinner = false;
      this.ready = true;
    }

  }

  public saveData(creditos: CreditosModel): void {
    const isNew = creditos.uid == null;
    const request = isNew
      ? this.creditosService.add(creditos)
      : this.creditosService.edit(creditos);

    this.spinner = true;
    this.loadingDialog.run(isNew ? 'Creando crédito…' : 'Guardando crédito…', request.then(ok => { if (ok !== true) throw new Error(); }))
      .then(() => {
        this.notify.ok(isNew ? 'Crédito creado correctamente' : 'Crédito actualizado correctamente');
        this.returnToIndex();
      })
      .catch(error => {
        const serverMessage = error && error.error && error.error.message;
        this.notify.error(serverMessage || (isNew ? 'Ha ocurrido un error inesperado al crear el crédito' : 'Ha ocurrido un error inesperado al actualizar el crédito'));
      })
      .then(() => { this.spinner = false; });
  }

  public displayError(error: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10500;
    this.snackBar.open(error, '', options);
  }

  public returnToIndex(): void {
    this.router.navigate(['finance/credits']);
  }

}
